export interface IPromocode {
    promocode: string
    liheID?: number
}

export class Promocode implements IPromocode {
    promocode: string
    liheID?: number
    constructor(
        promocode: string,
        liheID?: number
    ) {
        this.promocode = promocode
        this.liheID =  liheID
    }
}